import "./promo-bar-details.js";

class SectionPromoBar extends HTMLElement {
  constructor() {
    super();
    this.initFunction();

    const setHeightVariable = () =>
      document.documentElement.style.setProperty(
        "--promo-bar-height",
        `${this.getBoundingClientRect().height}px`,
      );
    window.requestAnimationFrame(setHeightVariable);
    window.addEventListener("resize", setHeightVariable);
  }

  initFunction() {
    const slides = this.querySelectorAll(".swiper-slide");
    if (slides.length < 2) {
      this.setMarquee(slides[0]);
      return;
    }

    window.loadSwiper.then(({ Swiper }) => {
      const swiperParams = {
        slidesPerView: "auto",
        speed: 750,
        loop: true,
        allowTouchMove: false,
        a11y: {
          enabled: false,
        },
        autoplay: {
          delay: 1000,
          disableOnInteraction: true,
        },
        navigation: {
          nextEl: this.querySelector("[data-promo-bar-navigation-next]"),
          prevEl: this.querySelector("[data-promo-bar-navigation-previous]"),
        },
        on: {
          slideChangeTransitionStart: () => {
            const activeSlide = this.swiper.slides[this.swiper.activeIndex];
            const { colorBg, color } = activeSlide.dataset;

            this.style.setProperty("--color-bg", colorBg);
            this.style.setProperty("--color", color);

            this.swiper.slides.forEach((slide) => {
              slide.setAttribute("aria-hidden", "true");
              slide.querySelectorAll("a, button").forEach((el) => {
                el.tabIndex = -1;
              });
            });
          },
          slideChangeTransitionEnd: () => {
            const activeSlide = this.swiper.slides[this.swiper.activeIndex];
            activeSlide.removeAttribute("aria-hidden");
            activeSlide.querySelectorAll("a, button").forEach((el) => {
              el.tabIndex = null;
            });

            this.setMarquee(activeSlide);

            this.swiper.slides.forEach((slide) => {
              if (slide === activeSlide) return;

              slide
                .querySelector(".promo-bar__block-content--marquee")
                ?.classList.remove("promo-bar__block-content--marquee");
            });
          },
          lock: () => {
            this.classList.add("promo-bar--locked");
          },
          unlock: () => {
            this.classList.remove("promo-bar--locked");
          },
          autoplayStop: () => this.setAutoplayState(),
        },
      };

      this.swiper = new Swiper(this.querySelector(".swiper"), swiperParams);

      const activeSlide = this.swiper.slides[this.swiper.activeIndex];

      this.swiper.slides.forEach((slide) => {
        if (slide === activeSlide) return;

        slide.setAttribute("aria-hidden", "true");
        slide.querySelectorAll("a, button").forEach((el) => {
          el.tabIndex = -1;
        });
      });

      this.addEventListener("click", (e) => {
        const toggle = e.target.closest(".promo-bar__autoplay-toggle");

        if (!toggle) return;

        if (this.swiper.autoplay.running && !this.swiper.autoplay.paused) {
          this.swiper.autoplay.pause();
        } else {
          if (this.swiper.autoplay.running) {
            this.swiper.autoplay.resume();
          } else {
            this.swiper.autoplay.start();
          }
        }

        this.setAutoplayState();
      });

      this.setAutoplayState();
      this.setMarquee(activeSlide);
    });
  }

  setAutoplayState() {
    if (!this.swiper.autoplay.running || this.swiper.autoplay.paused) {
      this.setAttribute("state", "paused");
    } else {
      this.setAttribute("state", "playing");
    }
  }

  setMarquee(slide) {
    const content = slide.querySelector(".promo-bar__block-content");
    const overflow =
      content.scrollWidth - content.getBoundingClientRect().width;

    if (overflow > 0) {
      slide.style.setProperty("--marquee-overflow", overflow);
    }

    content.classList.toggle("promo-bar__block-content--marquee", overflow > 0);
  }
}

if (!customElements.get("section-promo-bar")) {
  customElements.define("section-promo-bar", SectionPromoBar);
}
